import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment from 'moment'
import { FacultyPortalService } from 'src/app/services/FacultyPortal/faculty-portal.service';

@Component({
  selector: 'app-roll-number-generation',
  templateUrl: './roll-number-generation.component.html',
  styleUrls: ['./roll-number-generation.component.css']
})
export class RollNumberGenerationComponent implements OnInit {


  constructor(private facultyportalservice: FacultyPortalService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

  StudentList=[];
  Submitted: boolean = false;


  ClassDetails = {
    ClassSectionID:'',
    ClassID:0,
    SectionID:0,
  }

  
  SearchValidation() {
    return this.ClassDetails.ClassID == 0 || this.ClassDetails.SectionID == 0;
  }
  GetRollNumberGeneration() {
    this.Submitted = true;
    this.StudentList=[];
    if (!this.SearchValidation()) {
      var item = {
        ClassID: this.ClassDetails.ClassID,
        SectionId: this.ClassDetails.SectionID,
                 
    }

      this.spinnerService.show();
      this.facultyportalservice.GetRollNumberGeneration(JSON.stringify(item)).subscribe((data: any) => {
        this.StudentList = data.StudentList;      
        this.Submitted = false;
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(data);
      });
    }


  };


  SaveRollNumberGeneration() {
    this.Submitted = true;
    if (!this.SearchValidation()) {
    var item = {
      ClassID: this.ClassDetails.ClassID,
      SectionId: this.ClassDetails.SectionID,   
     
  }

    this.spinnerService.show();
    this.facultyportalservice.SaveRollNumberGeneration(JSON.stringify(this.StudentList), JSON.stringify(item)).subscribe((data: any) => {
      this.spinnerService.hide();
      this.Submitted = false;
      this.GetRollNumberGeneration();
      this.globalHelper.CheckActionStatus(data);

    });
  }
  };

  ngOnInit() {   
    this.GetClassSection();   
  }

  ClassSectionList: any;
  GetClassSection() {
    this.lookupservice.GetLookupsList('CTClassSection', '').subscribe((data) => {
      this.ClassSectionList = data.LookupItems;

    });

  };

  SetID() {
    this.StudentList=[];
    this.ClassDetails.ClassID = 0;
    this.ClassDetails.SectionID = 0;
    if (this.ClassDetails.ClassSectionID != "") {
      var strClassSectionID = this.ClassDetails.ClassSectionID.split('-');
      this.ClassDetails.ClassID = parseInt(strClassSectionID[0]);
      this.ClassDetails.SectionID = parseInt(strClassSectionID[1]);
      this.GetRollNumberGeneration();
    }



  }

}



